export default __webpack_public_path__ + "static/media/busMarkerDark.8f2b3ca4.svg";